import React, { Component } from "react";
import Context from "../../../context/Context";
import Topic from "../../../context/Topic";
import * as CrudComment from "../../base/transaction/comment";
import * as commentReplyUtil from "./commentReplyUtil";
import TextareaAutosize from 'react-textarea-autosize';
import { ButtonGroupInput } from "../../styles/commentsStyles";
import  { ThemeColorButton } from "../../styles/commentsStyles";

export default class InputComment extends Component {

    constructor(props){
        super(props);
        this.state={
            inputChange : '',
            emptyComment: false
        }
    }

    addComment =()=> {
        this.setState({
            inputChange : this.state.inputChange
        },
        function(){
            if(!this.state.inputChange){
                this.setState({
                    emptyComment : true
                })
            }else{
                const url = commentReplyUtil.getCommentUrl();
                const comment = this.state.inputChange;
                const author = Context.instance.user.getUsername();
                const openPlanId = Context.instance.spaceplanner.planId;
                const obj = {
                    comment : comment,
                    author : author,
                    planid : openPlanId
                }
                CrudComment.addComment(obj, url).then((response)=> {
                    if(response) {
                        this.setState({
                            commentId : response.data.addResults[0].objectId,
                            hideCallout : false,
                            inputChange : ''
                        })
                        Topic.publish(Topic.LoadComments, {});
                    }
                    this.setState({
                        emptyComment : false
                    })
                    this.props.closeInputComment();
                })
                .catch(error =>{
                    console.error(error);
                    Topic.publishErrorUpdatingData(error.message);
                })
            }
        })
    }

    handleCancel=()=>{
        this.props.closeInputComment();
    }

    handleInputChange =(evt)=> {
        this.setState({
            inputChange : evt.target.value
        },function(){
            if(!this.state.inputChange) {
                this.setState({
                    emptyComment : true
                })
            }else{
                this.setState({
                    emptyComment : false
                })
            }
        })
    }

    render(){
        const i18n = Context.instance.i18n;
        let showError;
        if(this.state.emptyComment) showError = i18n.spaceplanner.comments.emptyComment;
        return(
            <div style={{width: "100%"}}>
                <TextareaAutosize 
                    autoFocus
                    value={Context.sanitizeHtml(this.state.inputChange)}
                    style={{width: "97%", marginTop:"20px", borderColor:"#cacaca", fontFamily: "sans-serif", color:"#323232", padding:"5px"}} minRows={2} onChange={this.handleInputChange}/>
                <div style={{fontSize: "0.8125rem", color: "#808080"}}>{showError}</div>
                <ButtonGroupInput>
                    <ThemeColorButton  onClick={this.addComment}>{i18n.general.save}</ThemeColorButton>
                    <ThemeColorButton  onClick={this.handleCancel}>{i18n.general.cancel}</ThemeColorButton>
                </ButtonGroupInput>
            </div>
        )
    }
}